// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('base.paymentterms', {
        url: '/paymentterms?searchTerm',
        views: {
            'baseList': {
            templateUrl: 'main/base/paymentterms/paymentterms.tpl.html',
            controller: 'PaymentTermsController as vm'
        }},
        resolve: {
            paymentterms: paymenttermsResolver,
            searchTerm: searchTermesolver
        }
    });
}

// @ngInject
function paymenttermsResolver(PaymentTermsApiService, $stateParams) {
    return PaymentTermsApiService.getPaymentTerms({ page: 0, searchTerm:$stateParams.searchTerm, pageSize:null});
}

// @ngInject
function searchTermesolver($stateParams) {
    return $stateParams.searchTerm;
}

// @ngInject
function PaymentTermsController($rootScope, $state, $scope, paymentterms, PaymentTermsApiService, loadSpinnerService, searchTerm) {
    var vm = this;

    vm.currentUser = $rootScope.currentUser;

    vm.paymentterms = paymentterms;
    vm.selectedPaymentTermId = 0;
    vm.searchTerm = (searchTerm) ? searchTerm : '';
    vm.currentPage = 1;

    vm.searchTermChange = searchTermChange;

    activate();

    function activate() {
        $scope.$watch(function() { return $state.params.paymentTermId; }, function(newValue, oldValue) {
            vm.selectedPaymentTermId = parseInt($state.params.paymentTermId,10);
        });
        $rootScope.$on('PaymentTerm.Inserted', function(event, response) {
        });
        $rootScope.$on('PaymentTerm.Updated', function(event, response) {
        });
        $rootScope.$on('PaymentTerm.Deleted', function(event, response) {
        });
        $rootScope.$on('PaymentTerm.Changed', function(event, response) {
            loadPaymentTerms();
        });
    }

    function loadPaymentTerms() {
        loadSpinnerService.start('mainSpinner');
        var request = { page: (vm.currentPage - 1), searchTerm:vm.searchTerm, pageSize:vm.itemsPerPage};
        PaymentTermsApiService.getPaymentTerms(request).then(function(response) {
            vm.paymentterms = response;
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner',{force: true});
        });
    }

    function searchTermChange() {
        vm.currentPage = 1;
        loadPaymentTerms();
    }

}

angular
    .module('base.paymentterms', ['paymentterms.api','paymentterms.paymentterm'])
    .config(stateConfig)
    .controller('PaymentTermsController', PaymentTermsController);
